import { useEffect, useState } from 'react';
import { READINGS, fetchReading } from '@/models/author/service';
import type { Verse } from '@/models/author/types';

export function useAuthorController(): { verse: Verse | null } {
  const [reading] = useState<(typeof READINGS)[0]>(
    () => READINGS[Math.floor(Math.random() * READINGS.length)]!
  );
  const [verse, setVerse] = useState<Verse | null>(null);

  useEffect(() => {
    let isMounted = true;

    fetchReading(reading)
      .then((apiVerse) => {
        if (isMounted) {
          setVerse(apiVerse);
        }
      })
      .catch(() => {
        if (isMounted) {
          setVerse(reading.fallback);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [reading]);

  return { verse };
}
